module.exports = __webpack_public_path__ + "img/no6.78f8194c.jpg";